module.exports = __webpack_public_path__ + "static/scale-model-of-terror-on-the-plaza-haunted-house-in-san-antonio-texas-eb13e2fcef7a320920edd1df555ae660.png";